import React, {FC, ReactNode} from 'react'
import Loader from './Loader'

type TableLoadingShellProps = {
  loading: boolean
  children: ReactNode
  className?: string
  minHeight?: string
}

/** Centers loader over the visible table/card area (handles horizontal scroll). */
const TableLoadingShell: FC<TableLoadingShellProps> = ({
  loading,
  children,
  className = '',
  minHeight = '55vh',
}) => {
  return (
    <div
      className={`cmm-table-loading-shell ${className}`.trim()}
      style={{minHeight}}
      aria-busy={loading}
    >
      {loading ? (
        <div className='cmm-table-loading-overlay' role='status' aria-live='polite'>
          <Loader variant='section' />
        </div>
      ) : null}
      {children}
    </div>
  )
}

export default TableLoadingShell
